export default __webpack_public_path__ + "static/media/Flaticon.dc91b9c5.woff";